import { createApp } from 'vue'
import App from './App.vue'
import { registerPlugins } from './plugins'
import DropDown from './components/DropDown.vue'

import 'bootstrap/dist/js/bootstrap'
import 'bootstrap/scss/bootstrap.scss'
import 'primevue/resources/primevue.min.css'
import 'primeicons/primeicons.css'
import 'primevue/resources/themes/saga-blue/theme.css'
import '@fortawesome/fontawesome-free/scss/fontawesome.scss'
import '@fortawesome/fontawesome-free/scss/brands.scss'
import '@fortawesome/fontawesome-free/scss/solid.scss'
import '@fortawesome/fontawesome-free/scss/regular.scss'
import '@/assets/styles/theme.scss'
import '@/assets/styles/flags.css'

const app = createApp(App)
registerPlugins(app)
app.component('DropDown', DropDown)
app.mount('#app')